import "./App.css";
// src/index.js or src/main.jsx
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Home from "./Components/Pages/Home";
import Aboutus from "./Components/Pages/Aboutus";

import Internship from "./Components/Pages/Internship";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ContactUs from "./Components/Pages/Contactus";
// import Footer from "./Footer/Footer";
import Placement from "./Components/Pages/Placement";

import Navbar from "./Navbar/Navbar";
import Courses from "./Components/Pages/Course";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Aboutus" element={<Aboutus />} />

          <Route path="/Contactus" element={<ContactUs />} />
          <Route path="/Internship" element={<Internship />} />

          <Route path="/Placement" element={<Placement />} />
          <Route path="/Courses" element={<Courses />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
